import cn from 'clsx'

import { BlogTile } from 'shared-components'

import s from './Related.module.sass'

function Related({ relatedPosts }: any) {
    if (!relatedPosts?.length) return null

    return (
        <section className={s.Related}>
            <div className={cn(s.Cont, 'container')}>
                <h3>Related articles</h3>
                <div className={s.Posts}>
                    {relatedPosts?.map((post: any, index: number) => {
                        return <BlogTile post={post} key={index} />
                    })}
                </div>
            </div>
        </section>
    )
}

export default Related
